import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { ErrorToAllRequests } from '~/components/ErrorToAllRequests';
import { LoaderOverlay } from '~/components/Loader';
import { Page } from '~/components/Page';
import { RequestHeader } from '~/components/RequestHeader';
import { Retry } from '~/components/Retry';
import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';
import { IConfigurationRule } from '~/domain/IConfigurationRule';
import { IProductConfiguration } from '~/domain/IProductConfiguration';
import { useJiraConfigQuery } from '~/hooks/useJiraConfigQuery';
import { useProductConfigurationQuery } from '~/hooks/useProductConfigurationQuery';
import { useRequestQuery } from '~/hooks/useRequestQuery';
import { useRequestUrl } from '~/hooks/useRequestUrl';
import * as LAYOUT from '~/pages/layout';

import { SearchEimBody } from './SearchEimBody';

const emptyArray: unknown = [];

export const SearchEimPage = React.memo(function SearchEimPage() {
  const { isError: isJiraConfigError, refetch: refetchJiraConfig } = useJiraConfigQuery();
  const { data: request, isError: isRequestError } = useRequestQuery();
  const location = useLocation();
  const requestUrl = useRequestUrl();
  const { eim: invalidEim, f: invalidFeatures, ...state } = location.state || {};
  
  const {
    data: {
      // eims = emptyArray as string[],
      packSets = emptyArray as IConfigurationOptionGroup[],
      eimPackSets = emptyArray as IConfigurationOptionGroup[],
      rules = emptyArray as IConfigurationRule[],
      client,
      vehicle,
      year,
    } = {} as IProductConfiguration,
    isLoading,
    isError,
  } = useProductConfigurationQuery();

  // const isMissingAssetsOld = (request && request.requestId && !request.addressableRegion)
  //   || isError
  //   || (!isLoading && packSets.length < 1);
  
  let isMissingAssets = false;
  if (client !== 'subaru') {
    isMissingAssets = (request && request.requestId && !request.addressableRegion)
      || isError
      || (!isLoading && packSets.length < 1);
  } else {
    isMissingAssets = isError || isLoading;
  }

  // console.log('SearchEimPage ====================')
  // console.log('SearchEimPage +++++++++++++++ isError: ', isError)
  // console.log('SearchEimPage +++++++++++++++ isLoading: ', isLoading)
  // console.log('SearchEimPage +++++++++++++++ isMissingAssets: ', isMissingAssets)
  // console.log('SearchEimPage +++++++++++++++ isRequestError: ', isRequestError)
  // console.log('SearchEimPage ====================')

  // check if user was trying to load url with invalid eim or features
  // in that case, allow user to search for the eim
  // if (!invalidEim && !invalidFeatures && eims?.length) {
  //   return <Navigate to={requestUrl({ ...state, eim: eims[0] })} replace />
  // }

  if (client === 'subaru') {
    return <Navigate to={requestUrl({ ...state, eim: `${vehicle}_${year}`})} replace />
  }

  return (
    <Page title={request?.title}>
      <Box sx={[LAYOUT.HEADER]}>
        <RequestHeader />
      </Box>
      <Box sx={[LAYOUT.BODY, {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }]}>
        {isJiraConfigError && <Retry retry={refetchJiraConfig} sx={{ margin: 'auto', transform: 'translateY(-50%)' }}>the markets</Retry>}
        {isRequestError && <ErrorToAllRequests maxTextWidth={424}>Sorry, the request you are looking for doesn&apos;t exist</ErrorToAllRequests>}
        {!isRequestError && isLoading && (<LoaderOverlay sx={{ height: '90%' }} />)}
        
        {/* created new condition, old commented out. Keeping Request Error prop. Removed is missing because we are doing partial builds now. Added is loading instead. Common sense says this should not show if ISLOADING===true. */}
        {!isRequestError && !isLoading && (<ErrorToAllRequests maxTextWidth={450}>Assets for this request are still in production, please check in later</ErrorToAllRequests>)}

        {/* Old Condition */}
        {/* {!isRequestError && isMissingAssets && (<ErrorToAllRequests maxTextWidth={450}>Assets for this request are still in production, please check in later, DUDE!!</ErrorToAllRequests>)} */}
        
        {!isRequestError && !isMissingAssets && !isLoading && (
          <SearchEimBody eimPackSets={eimPackSets} packSets={packSets} rules={rules} />
        )}
      </Box>
    </Page>
  );
});
